module.exports = __webpack_public_path__ + "static/media/logo-rounded.1e9ab494.png";